module.exports = __webpack_public_path__ + "img/1561656584.4cbfa0f9.jpg";